import CollapseIcon from 'components/SVG/Collapse';
import { Heading } from 'components/v2/Typography/Heading';
import { Text } from 'components/v2/Typography/Text';
import styled from 'styled-components';

export const Wrapper = styled.div<{ $optional: boolean }>`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;

export const Title = styled(Heading).attrs({ tag: 'h2', styledAs: 'h5', noMargin: true })`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const OptionalHeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
`;

export const OptionalHeaderDescription = styled(Text).attrs({ tag: 'span', size: 'md' })`
  text-align: left;
`;

export const OptionalHeader = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  text-align: left;

  &:hover {
    cursor: pointer;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.neutral.lightNavy};
    outline-offset: 4px;
  }
`;

export const OptionalHeaderIcon = styled(CollapseIcon)<{ $expanded: boolean }>`
  transform: ${({ $expanded }) => ($expanded ? 'rotate(0deg)' : 'rotate(180deg)')};
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  background: white;
  gap: 24px;
`;
